/**
 * @generated SignedSource<<c0d78aef41b2d2f1c1e7f9ae85b95c61>>
 * @relayHash 935edef33b726a71add51ad8533488f2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 935edef33b726a71add51ad8533488f2

import { ConcreteRequest } from 'relay-runtime';
export type StartOutboundCallInput = {
  appointmentId: string;
  isRecorded?: boolean | null;
  phoneNumber: string;
};
export type useStartOutboundCallMutation$variables = {
  input: StartOutboundCallInput;
};
export type useStartOutboundCallMutation$data = {
  readonly startOutboundCall: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly startOutboundCallOutput: {
      readonly result: boolean;
    } | null;
  };
};
export type useStartOutboundCallMutation = {
  response: useStartOutboundCallMutation$data;
  variables: useStartOutboundCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "StartOutboundCallOutput",
  "kind": "LinkedField",
  "name": "startOutboundCallOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "result",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useStartOutboundCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "StartOutboundCallPayload",
        "kind": "LinkedField",
        "name": "startOutboundCall",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useStartOutboundCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "StartOutboundCallPayload",
        "kind": "LinkedField",
        "name": "startOutboundCall",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "935edef33b726a71add51ad8533488f2",
    "metadata": {},
    "name": "useStartOutboundCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8cc7a63297df4132fbc256168e826657";

export default node;
